import isFunction from 'lodash-es/isFunction';

export { flushCallback, registerCallback }

const callbacks = {};

function flushCallback(event) {
  const cb = callbacks[event];
  if (isFunction(cb)) {
    cb();
  }
}

function registerCallback(event, cb) {
  callbacks[event] = cb;
}
